import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from 'react';
import { cssTransition, toast } from 'react-toastify';
import Notification, { INDICATION } from '../components/Notification';
import '../assets/style/scss/partials/_slide.scss';
const Slide = cssTransition({
    enter: 'slideIn',
    exit: 'slideOut',
    duration: 300,
});
const defaults = {
    transition: Slide,
    position: 'top-center',
    hideProgressBar: true,
    pauseOnHover: true,
    newestOnTop: true,
    closeButton: false,
    closeOnClick: false,
    draggable: false,
    pauseOnFocusLoss: false,
};
function notify(type, message, notificationOptions = {}, toastOptions = {}) {
    const { description, action, onClick, title, className, btnVariant, onCloseClick, descriptionInTooltip, showOverflow, creditsCharged, } = notificationOptions;
    const notification = (_jsx(Notification, { indication: type, message: message, description: description, action: action, title: title, onClick: onClick, className: className, btnVariant: btnVariant, onCloseClick: onCloseClick, descriptionInTooltip: descriptionInTooltip, showOverflow: showOverflow, creditsCharged: creditsCharged }));
    toast(notification, toastOptions);
}
function updateToast(toastId, type, message, notificationOptions = {}, toastOptions = {}) {
    const { description, action, onClick, title, className, btnVariant, onCloseClick, descriptionInTooltip, showOverflow, } = notificationOptions;
    const notification = (_jsx(Notification, { indication: type, message: message, description: description, action: action, title: title, onClick: onClick, className: className, btnVariant: btnVariant, onCloseClick: onCloseClick, descriptionInTooltip: descriptionInTooltip, showOverflow: showOverflow }));
    toast.update(toastId, Object.assign(Object.assign({}, toastOptions), { render: notification }));
}
export const notifySuccess = (message, options) => {
    notify(INDICATION.SUCCESS, message, options, Object.assign(Object.assign({}, defaults), { autoClose: 3000 }));
};
export const notifyFail = (message, options, isAutoClose = false) => {
    notify(INDICATION.FAIL, message, options, Object.assign(Object.assign({}, defaults), { autoClose: isAutoClose }));
};
const notifyBlueFail = (message, options, toastId, autoClose = false) => {
    notify(INDICATION.BLUE_FAIL, message, options, Object.assign(Object.assign({}, defaults), { autoClose, toastId }));
};
const updateToastById = (message, type, options, toastId) => {
    updateToast(toastId, type, message, options, Object.assign(Object.assign({}, defaults), { autoClose: false }));
};
const engageNotifier = (type, message, options) => {
    const method = type === 'success' ? notifySuccess : notifyFail;
    method(message, options);
};
export const dismissNotifications = () => toast.dismiss();
const dismissById = toastId => toast.dismiss(toastId);
const useNotification = () => ({
    success: notifySuccess,
    fail: notifyFail,
    blueFail: notifyBlueFail,
    dismiss: dismissNotifications,
    dismissById,
    update: updateToastById,
    engageNotifier,
});
export default useNotification;
